import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useDocumentDirection(): 'ltr' | 'rtl' {
  const { i18n } = useTranslation();
  return useMemo(() => {
    // well, we would much rather show rtl with some arabic than ltr with some arabic
    return i18n.dir(i18n.language);
  }, [i18n.language]);
}

export function useUpdateDocumentRtl() {
  const dir = useDocumentDirection();

  useEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);
}
